import React from 'react';
import { FocusScope } from 'react-aria';
import { useIntl } from 'react-intl';
import { Portal } from '@magento/venia-ui/lib/components/Portal';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import { Button, CloseIcon } from '../../components';
import CategoryFilterForm from './categoryFilterForm';
import classes from './categoryFilterModal.module.css';
import bottomClasses from '../../components/FilterModal/CurrentFilters/mobileCurrentFilters.module.css';

var CategoryFilterModal = function CategoryFilterModal(_ref) {
  var toggleModal = _ref.toggleModal,
      isOpen = _ref.isOpen,
      handleCheckboxClick = _ref.handleCheckboxClick,
      subCategories = _ref.subCategories,
      selectedSubcategories = _ref.selectedSubcategories,
      resetSelectedSubcategories = _ref.resetSelectedSubcategories;
  var modalClass = isOpen ? classes.root_open : classes.root;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var filtersAriaLabel = formatMessage({
    id: 'filterModal.filters.ariaLabel',
    defaultMessage: 'Filters'
  });
  var closeAriaLabel = formatMessage({
    id: 'filterModal.filters.close.ariaLabel',
    defaultMessage: 'Close filters popup.'
  });
  var clearAllAriaLabel = formatMessage({
    id: 'filterModal.action.clearAll.ariaLabel',
    defaultMessage: 'Clear all applied filters'
  });

  var handleReset = function handleReset() {
    resetSelectedSubcategories();
    toggleModal();
  };

  return React.createElement(Portal, null, React.createElement(FocusScope, {
    contain: true,
    restoreFocus: true,
    autoFocus: true
  }, React.createElement("aside", {
    className: modalClass
  }, React.createElement("div", {
    className: classes.body
  }, React.createElement("div", {
    className: classes.header
  }, React.createElement("div", {
    className: classes.headerTitle
  }, "Refine Categories "), React.createElement("button", {
    onClick: toggleModal,
    "aria-disabled": false,
    "aria-label": closeAriaLabel,
    className: classes.closeBtn
  }, React.createElement(CloseIcon, null))), React.createElement("ul", {
    className: classes.blocks,
    "aria-label": filtersAriaLabel
  }, React.createElement(CategoryFilterForm, {
    handleCheckboxClick: handleCheckboxClick,
    subCategories: subCategories,
    selectedSubcategories: selectedSubcategories
  })), React.createElement("div", {
    className: bottomClasses.root
  }, React.createElement(Button, {
    priority: "high",
    "aria-label": "Show results",
    fullWidth: true,
    onClick: toggleModal
  }, "SHOW RESULTS"), React.createElement("div", {
    className: "flex text-white justify-between mt-4 w-full"
  }, React.createElement(Trigger, {
    action: handleReset,
    classes: {
      root: classes.triggerRoot
    },
    "aria-label": "Clear all"
  }, "Clear All")))))));
};

export default CategoryFilterModal;